import { useState, useEffect } from 'react';

const useTransitData = (lat = 28.63576, lon = 77.22445) => {
  const [transitData, setTransitData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const baseURL = process.env.NODE_ENV === 'production' ? '' : (process.env.REACT_APP_API_BASE_URL || `http://${window.location.hostname}:5001`);
    setLoading(true);
    fetch(`${baseURL}/api/ephemeris/transits?lat=${lat}&lon=${lon}`)
      .then(r => r.json())
      .then(data => { if (!cancelled) { setTransitData(data); setLoading(false); } })
      .catch(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [lat, lon]);

  return { transitData, loading };
};

export default useTransitData;
